import * as React from 'react'
import {FormattedDate} from 'react-intl'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {differenceInDays} from 'date-fns/differenceInDays'
import {getSearchParameters} from 'modules/sapiSearch/selectors'
import {getSelectedAvailabilityDate} from 'modules/search/selectors'

import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'
import {getCheckOutDate} from '@vio/core/src/searchParams/validateSearchParamDates'
import {dateStringToMiddayDate} from '@vio/core/src/utils/date'

export enum DatesTypes {
  Search = 'search',
  Availability = 'availability'
}
interface Props {
  datesType?: DatesTypes
  shouldWrapDates?: boolean
  showDatesOnly?: boolean
}

const ShortFormattedDate = ({value}: {value: Date}) => (
  <FormattedDate value={value} month="short" day="2-digit" />
)

const TextWrapper = styled.span`
  white-space: nowrap;
`

export const SoldOutBodyMessage = ({
  datesType = DatesTypes.Search,
  shouldWrapDates = false,
  showDatesOnly = false
}: Props) => {
  const searchParams = useSelector(getSearchParameters)
  const selectedAvailabilityCheckIn = useSelector(getSelectedAvailabilityDate)
  const nights = differenceInDays(
    dateStringToMiddayDate(searchParams?.checkOut),
    dateStringToMiddayDate(searchParams?.checkIn)
  )
  const selectedAvailabilityCheckOut = getCheckOutDate(
    selectedAvailabilityCheckIn,
    nights
  )

  const checkInDate = dateStringToMiddayDate(
    datesType === DatesTypes.Search
      ? searchParams?.checkIn
      : selectedAvailabilityCheckIn
  )
  const checkOutDate =
    datesType === DatesTypes.Search
      ? dateStringToMiddayDate(searchParams?.checkOut)
      : selectedAvailabilityCheckOut

  if (shouldWrapDates) {
    return (
      <span>
        <FormattedMessageWrapper id="soldOutTitle" defaultMessage="Sold out" />
        <br />
        <TextWrapper>
          <ShortFormattedDate value={checkInDate} />
        </TextWrapper>
        <span> - </span>
        <TextWrapper>
          <ShortFormattedDate value={checkOutDate} />
        </TextWrapper>
      </span>
    )
  }

  if (showDatesOnly) {
    return (
      <FormattedMessageWrapper
        dataId="soldOut.messageWithDates"
        id="soldOut.showDatesOnlyMessage"
        defaultMessage="{checkIn} - {checkOut}"
        values={{
          checkIn: (
            <TextWrapper>
              <ShortFormattedDate value={checkInDate} />
            </TextWrapper>
          ),
          checkOut: (
            <TextWrapper>
              <ShortFormattedDate value={checkOutDate} />
            </TextWrapper>
          )
        }}
      />
    )
  }
  return (
    <FormattedMessageWrapper
      dataId="soldOut.messageWithDates"
      id="soldOut.messageWithDatesB"
      defaultMessage="Sold out {checkIn} - {checkOut}"
      values={{
        checkIn: (
          <TextWrapper>
            <ShortFormattedDate value={checkInDate} />
          </TextWrapper>
        ),
        checkOut: (
          <TextWrapper>
            <ShortFormattedDate value={checkOutDate} />
          </TextWrapper>
        )
      }}
    />
  )
}
